module.exports = "/_next/static/images/email_verification-f138f6e75e26e7fcb27766a19f755c6e.svg";